import React from 'react';
import PropTypes from 'prop-types';
import Filter from './filter/Filter';
import PrintHelper from 'print-helper-lib';
import { Search } from 'web-ui-components/lib/molecules/forms';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import envConfig from '../../../../static/config';

const PaymentHistorySMEDetail = ({
  onPaymentStatusSelect,
  onDateIntervalChange,
  onFromDateChange,
  onToDateChange,
  onSearchChange,
  filterCriteria,
  gridClasses,
  columns,
  results,
  renderFooter,
  onSortChange,
  content,
}) => {
  return (
    <div>
      <section className="payment-history-filter payment-history-filter--sme">
        <Filter
          handlePaymentStatusSelect={onPaymentStatusSelect}
          handleDateIntervalChange={onDateIntervalChange}
          handleFromDateChange={onFromDateChange}
          handleToDateChange={onToDateChange}
          filterCriteria={filterCriteria}
          content={content}
        />
        <div className="web-ui-components search-wrapper">
          <Search
            cancelButtonText="Cancel"
            onChange={(searchTerm) => {
              onSearchChange(searchTerm);
            }}
            placeholder="Search"
          />
        </div>
      </section>
      <PrintHelper
        className="web-ui-components"
        brandId={envConfig.brandId}
        showPrintTopIcon={false}
        showPrintBottomIcon
      >
        <div className="headerflagClass">
          <section className="web-ui-components">
            <div className={gridClasses}>
              <DataTable
                layout="transactions"
                columns={columns}
                data={results}
                isBranded
                keyPath={['id']}
                onHeaderCellClick={onSortChange}
              />
              <div className="manage-payment-history-footer">
                {renderFooter()}
              </div>
            </div>
          </section>
        </div>
      </PrintHelper>
    </div>
  );
};

PaymentHistorySMEDetail.propTypes = {
  onPaymentStatusSelect: PropTypes.func.isRequired,
  onDateIntervalChange: PropTypes.func.isRequired,
  onFromDateChange: PropTypes.func.isRequired,
  onToDateChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  filterCriteria: PropTypes.object.isRequired,
  brandId: PropTypes.string.isRequired,
  gridClasses: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  results: PropTypes.array.isRequired,
  renderFooter: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  content: PropTypes.shape({}),
};

export default PaymentHistorySMEDetail;
